module.exports = __webpack_public_path__ + "img/co-branding-logo-mcdonalds.23450b50.png";